const REFRESH_LEEWAY_MS = 0;

let refreshPromise = null;
let monitorTimer = null;

function getStorage() {
  if (typeof window === "undefined" || !window.localStorage) return null;
  return window.localStorage;
}

export function getCurrentAccessToken() {
  const storage = getStorage();
  return storage ? storage.getItem("t_k") || "" : "";
}

function getStoredTokenData() {
  const storage = getStorage();
  if (!storage) return {};
  try {
    const value = storage.getItem("token");
    return value ? JSON.parse(value) || {} : {};
  } catch (error) {
    return {};
  }
}

function decodeJwtPayload(token) {
  const parts = String(token || "").split(".");
  if (parts.length !== 3) return null;
  try {
    const normalized = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    const binary = window.atob(padded);
    const json = decodeURIComponent(
      Array.prototype.map
        .call(binary, (char) =>
          `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`,
        )
        .join(""),
    );
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

function getExpireAt(token, tokenData) {
  const payload = decodeJwtPayload(token);
  if (payload && Number(payload.exp) > 0) return Number(payload.exp) * 1000;

  const candidates = [
    tokenData && tokenData.expireTime,
    tokenData && tokenData.expiresAt,
    tokenData && tokenData.expiredAt,
  ];
  const value = candidates.find((item) => Number(item) > 0);
  if (!value) return 0;

  const numericValue = Number(value);
  if (numericValue >= 100000000000) return numericValue;
  if (numericValue >= 1000000000) return numericValue * 1000;

  const storage = getStorage();
  const storedAt = Number(storage && storage.getItem("time"));
  if (!storedAt) return 0;
  const durationMs = numericValue < 10000000
    ? numericValue * 1000
    : numericValue;
  return storedAt + durationMs;
}

export function isAccessTokenExpiring(token = getCurrentAccessToken()) {
  if (!token) return false;
  const expireAt = getExpireAt(token, getStoredTokenData());
  return !!expireAt && expireAt - Date.now() <= REFRESH_LEEWAY_MS;
}

export async function refreshAccessTokenSilently() {
  if (refreshPromise) return refreshPromise;
  const expiredToken = getCurrentAccessToken();
  if (!expiredToken) return "";

  refreshPromise = import("@/utils/storageHelper.js")
    .then(({ clearStorageAndRedirectToLogin }) => {
      const currentToken = getCurrentAccessToken();
      if (currentToken === expiredToken) {
        clearStorageAndRedirectToLogin();
      }
      return "";
    })
    .catch((error) => {
      console.error("[认证] 处理过期登录态失败", error);
      return "";
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

export async function getLatestAccessToken(options = {}) {
  const currentToken = getCurrentAccessToken();
  if (options.refreshIfExpiring && isAccessTokenExpiring(currentToken)) {
    return refreshAccessTokenSilently();
  }
  return currentToken;
}

export function startAccessTokenMonitor() {
  if (monitorTimer || typeof window === "undefined") return;
  if (isAccessTokenExpiring()) refreshAccessTokenSilently();
  monitorTimer = window.setInterval(() => {
    if (isAccessTokenExpiring()) refreshAccessTokenSilently();
  }, 30 * 1000);
}

export function stopAccessTokenMonitor() {
  if (!monitorTimer || typeof window === "undefined") return;
  window.clearInterval(monitorTimer);
  monitorTimer = null;
}

if (module.hot) {
  module.hot.dispose(() => {
    stopAccessTokenMonitor();
  });
}
